

































































import { COLOR_SELECTED_NON_DEFAULT_FILTER_BACKGROUND, COLOR_SELECTED_NON_DEFAULT_FILTER_BACKGROUND_DARK, COLOR_SELECTED_NON_DEFAULT_TOOLBAR_FILTER_BACKGROUND } from "@/utils/colors";
import { themed } from "@/utils/Theme";
import { Vue, Component, Prop, Model } from "vue-property-decorator";

@Component
export default class MenuIconWithSelectionListComponent<T> extends Vue {
  @Prop({ default: "mdi-sort-alphabetical-variant" })
  iconResource!: string;

  @Prop({ default: "white" })
  iconColor!: string;

  @Prop({ default: true })
  isToolbarIcon!: boolean;

  @Prop({ default: false })
  disabled!: boolean;

  @Prop()
  tooltip!: string;

  @Prop({ default: [] })
  selectionOptions!: Array<T>;

  @Prop()
  getOptionName!: (value: T) => string;

  @Prop()
  getOptionKeyCallback?: (value: T) => string;

  /** An option's group heading, shown above the first option of each group; absent for a flat list. */
  @Prop()
  getOptionGroup?: (value: T) => string;

  /**
   * Whether the groups open and close by their heading (Mira's calendar, 2026-11-03). Opening the menu
   * expands the first group and the chosen option's; the rest stay closed, so a long list stays short.
   */
  @Prop({ type: Boolean, default: false })
  collapsibleGroups!: boolean;

  // Initialised, not `!`: a template reads it from the first render (ui-conventions, Reactivity).
  expandedGroups: string[] = [];

  isGroupExpanded(group: string | undefined): boolean {
    return group === undefined || this.expandedGroups.includes(group);
  }

  toggleGroup(group: string | undefined) {
    if (group === undefined) return;
    this.expandedGroups = this.isGroupExpanded(group)
      ? this.expandedGroups.filter((entry) => entry !== group)
      : [...this.expandedGroups, group];
  }

  /** On opening, the first group and the chosen option's group are expanded. */
  onMenuToggle(open: boolean) {
    if (!open || !this.collapsibleGroups || !this.getOptionGroup || this.selectionOptions.length === 0) return;
    const groups = [this.getOptionGroup(this.selectionOptions[0])];
    if (this.selectionOptions.some((option) => this.getKey(option) === this.getKey(this.selectedValue))) {
      groups.push(this.getOptionGroup(this.selectedValue));
    }
    this.expandedGroups = [...new Set(groups)];
  }

  /** Whether the option at `index` opens a new group (always false without {@link getOptionGroup}). */
  startsGroup(index: number): boolean {
    if (!this.getOptionGroup) return false;
    return index === 0 || this.getOptionGroup(this.selectionOptions[index]) !== this.getOptionGroup(this.selectionOptions[index - 1]);
  }

  getOptionKey(value: T) {
    if (this.getOptionKeyCallback) {
      return this.getOptionKeyCallback(value);
    } else {
      value;
    }
  }

  @Model("valueChanged")
  selectedValue!: T;

  get selectedValues() {
    const keySelected = this.getKey(this.selectedValue);
    return [keySelected];
  }

  selectOption(value: T) {
    this.$emit("valueChanged", value);
  }

  getKey(value: T) {
    return this.getOptionKeyCallback ? this.getOptionKeyCallback(value) : value;
  }

  get style() {
    const hasSelectedFirstOption =
      this.getKey(this.selectionOptions[0]) == this.getKey(this.selectedValue);

    return hasSelectedFirstOption
      ? ""
      : this.isToolbarIcon
        ? `background-color: ${COLOR_SELECTED_NON_DEFAULT_TOOLBAR_FILTER_BACKGROUND}`
        : `background-color: ${themed(COLOR_SELECTED_NON_DEFAULT_FILTER_BACKGROUND, COLOR_SELECTED_NON_DEFAULT_FILTER_BACKGROUND_DARK)}`;
  }
}
